module.exports = __webpack_public_path__ + "media/honey-icons/icon-sales-ed5a68fc.svg";